import transform from 'lodash/transform.js';
import isPlainObject from 'lodash/isPlainObject.js';
import isEmpty from 'lodash/isEmpty.js';
export function cleanDeep(object, { cleanKeys = [], cleanValues = [], emptyArrays = true, emptyObjects = true, emptyStrings = true, NaNValues = false, nullValues = true, undefinedValues = true } = {}) {
    return transform(object, (result, value, key) => {
        if (cleanKeys.includes(key)) {
            return;
        }
        if (Array.isArray(value) || isPlainObject(value)) {
            value = cleanDeep(value, { NaNValues, cleanKeys, cleanValues, emptyArrays, emptyObjects, emptyStrings, nullValues, undefinedValues });
        }
        if (cleanValues.includes(value)) {
            return;
        }
        if (emptyObjects && isPlainObject(value) && isEmpty(value)) {
            return;
        }
        if (emptyArrays && Array.isArray(value) && !value.length) {
            return;
        }
        if (emptyStrings && value === '') {
            return;
        }
        if (NaNValues && Number.isNaN(value)) {
            return;
        }
        if (nullValues && value === null) {
            return;
        }
        if (undefinedValues && value === undefined) {
            return;
        }
        if (Array.isArray(result)) {
            return result.push(value);
        }
        result[key] = value;
    });
}
;
